<template>
  <div class="un">
    <div class="icon">
      <img :src="unPublish" alt />
      <p>{{!unPublishType?'该活动已删除!':'活动暂未发布，当前仅供浏览'}}</p>
    </div>
    <van-button round type="primary" @click="next" v-if="unPublishType">我知道了</van-button>
  </div>
</template>

<script>
import { getBreakthroughDetailNo } from "@/api/stormPassAnswer";
export default {
  data() {
    return {
      unPublish: require("../../assets/img/noData.png"),
      unPublishType: true
    };
  },
  created() {
    // document.title = "闯关赢电视";
    console.log(this.$route.query.id);
    getBreakthroughDetailNo({ webBreakthroughId: this.$route.query.id }).then(
      ({ data }) => {
        if (data.code == 200) {
          console.log(data.data);
          document.title = data.data.webBreakthroughTitle;
        } else if (data.code == 99997) {
          this.unPublishType=false
          this.unPublish = require("../../assets/img/Frame.png");
        }
      }
    );
  },
  methods: {
    next() {
      localStorage.setItem("noPubilsh", 1);
      this.$router.push({
        path: "/stormPassAnswer",
        query: {
          webTenId: this.$route.query.webTenId,
          id: this.$route.query.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.un {
  overflow: hidden;
  .icon {
    width: 61%;
    margin: 1.76rem auto 0;
    > p {
      font-size: 0.32rem;
      color: #666666;
      text-align: center;
    }
    > img {
      width: 100%;
    }
  }
  /deep/ .van-button--round {
    width: 50%;
    margin: 60px auto 0;
    display: block;
    background-color: #5f73f9;
    border: 1px solid #5f73f9;
  }
}
</style>